import { Component, EventEmitter, inject, Output, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { APP_ROUTES } from '../../constants/routes.const';
import { AuthService } from '../../auth/services/auth.service';
import { ToastModule } from 'primeng/toast';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { PopoverModule } from 'primeng/popover';
import { ReportarErrorDialogComponent } from './dialogs/reportar-error-dialog/reportar-error-dialog.component';
import { LegalDialogsComponent } from './dialogs/legal-dialogs/legal-dialogs.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    TieredMenuModule,
    ButtonModule,
    AvatarModule,
    ToastModule,
    PopoverModule,
    ReportarErrorDialogComponent,
    LegalDialogsComponent,
  ],
  providers: [MessageService],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Output() menuToggle = new EventEmitter<void>();

  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly messages = inject(MessageService);

  loggingOut = signal(false);

  modalErrorVisible = false;
  legalVisible = false;
  legalTipo: 'aviso-legal' | 'privacidad' | 'cookies' | 'condiciones' = 'aviso-legal';

  readonly items: MenuItem[] = [
    { label: 'Perfil', icon: 'pi pi-user', command: () => this.openProfile() },
    { label: 'Ajustes', icon: 'pi pi-cog', command: () => this.openSettings() },
    { separator: true },
    { label: 'Cerrar sesión', icon: 'pi pi-sign-out', command: () => this.onLogout() },
  ];

  abrirModalError() {
    this.modalErrorVisible = true;
  }

  abrirPagina(tipo: 'aviso-legal' | 'privacidad' | 'cookies' | 'condiciones') {
    this.legalTipo = tipo;
    this.legalVisible = true;
  }

  private openProfile() {
    this.messages.add({ severity: 'info', summary: 'Perfil', detail: 'Abrir perfil (mock)' });
  }

  private openSettings() {
    this.messages.add({ severity: 'info', summary: 'Ajustes', detail: 'Abrir ajustes (mock)' });
  }

  onLogout() {
    if (this.loggingOut()) return;

    this.loggingOut.set(true);
    this.auth.logout().subscribe({
      next: () => {
        this.messages.add({
          severity: 'success',
          summary: 'Sesión cerrada',
          detail: 'Has salido correctamente',
        });
        this.router.navigate([`/${APP_ROUTES.LOGIN}`]);
      },
      error: () => {
        this.messages.add({
          severity: 'info',
          summary: 'Sesión finalizada',
          detail: 'Se ha cerrado la sesión',
        });
      },
      complete: () => this.loggingOut.set(false),
    });
  }
}
